<template>
  <div class="container mt-4">
    <TopNav
      :title="$t('GENERAL.LINK.PRODUCT_TAGS')"
      :showOpenMainNav="true"
      :icon="['far', 'folder-open']"
    >
      <NavItem
        icon="fal fa-plus"
        :text="$t('PRODUCTS.LINK.ADD_PRODUCT_TAG')"
        @click.native="addTag"
      />
    </TopNav>
    <div class="mt-4" v-show="!isLoading && !showEmpty">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">
              {{ $t('PRODUCTS.PRODUCT_TAGS.NAME') }}
            </th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tr v-for="tag in productTags" :key="tag.id">
          <td class="h5 m-0 align-middle">
            {{ tag.name }}
          </td>
          <HMTableButton
            v-confirm="{
              title: $t('PRODUCTS.TITLE.DELETE_PRODUCT_TAG'),
              text: $t('PRODUCTS.TEXT.DELETE_PRODUCT_TAG_DESCRIPTION'),
              confirmButton: $t('GENERAL.BUTTON.DELETE'),
              confirm: () => deleteTag(tag),
            }"
            icon="trash-alt"
          />
          <HMTableButton @click="editTag(tag)" icon="pen" />
        </tr>
      </table>
    </div>
    <div v-if="!isLoading && showEmpty" class="text-center">
      <HMEmpty
        image=""
        :title="$t('PRODUCTS.TEXT.PRODUCT_TAGS_EMPTY')"
        :description="$t('PRODUCTS.TEXT.EMPTY_PRODUCT_TAGS_DESCRIPTION')"
      />
      <button
        @click="addTag"
        type="button"
        name="button"
        class="btn btn-primary"
      >
        {{ $t('PRODUCTS.LINK.ADD_PRODUCT_TAG') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import ProductTagDialog from '@/web/components/products/ProductTagDialog.vue';
import { errorToMessage } from '@/core/utils/errors';

export default {
  name: 'ProductTags',
  components: {
    TopNav,
    NavItem,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      productTags: 'product/productTags',
    }),
    showEmpty() {
      return this.productTags?.length === 0;
    },
  },
  methods: {
    addTag() {
      this.$modal.show(ProductTagDialog, {
        onConfirm: async tag => {
          try {
            this.isLoading = true;
            await this.$store.dispatch('product/addProductTag', tag);
            await this.loadData();
          } catch (error) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Failed to add a product tag',
              text: errorToMessage(error?.response, `Request failed: ${error}`),
              duration: -1,
            });
          } finally {
            this.isLoading = false;
          }
        },
      });
    },
    editTag(productTag) {
      this.$modal.show(ProductTagDialog, {
        productTag,
        onConfirm: async tag => {
          try {
            this.isLoading = true;
            await this.$store.dispatch('product/updateProductTag', tag);
            await this.loadData();
          } catch (error) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Failed to update product tag',
              text: errorToMessage(error?.response, `Request failed: ${error}`),
              duration: -1,
            });
          } finally {
            this.isLoading = false;
          }
        },
      });
    },
    async deleteTag({ id }) {
      await this.$store.dispatch('product/deleteProductTag', id);
      await this.loadData();
    },
    async loadData() {
      try {
        this.isLoading = true;
        await this.$store.dispatch('product/getProductTags');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load product tags',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.icon-tr {
  position: relative;
}

.icon-tr-icon {
  position: absolute;
  left: 0;
  top: 0;
  width: 1.5rem;
  height: 1.5rem;
}

.tag {
  margin: 0.2rem;
}
</style>
